// src/services/api/feedbacks.ts
import { apiClient, ApiResponse } from './index';

export interface Feedback {
  id: string;
  order_number: string;
  customer_name: string;
  customer_phone: string;
  rating: number;
  comment: string;
  date: string;
  response_time_minutes: number | null;
  is_approved: boolean;
  moderated_at: string | null;
  moderated_by: string | null;
}

export interface FeedbackStats {
  total_reviews: number;
  pending_moderation: number;
  approved: number;
  average_rating: number;
  distribution: {
    '1': number;
    '2': number;
    '3': number;
    '4': number;
    '5': number;
  };
}

export interface FeedbacksResponse {
  reviews: Feedback[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    has_more: boolean;
  };
  stats: FeedbackStats;
}

export const feedbacksApi = {
  // Получить список отзывов с фильтрами
  getFeedbacks: (params?: {
    limit?: number;
    offset?: number;
    rating?: number;
    status?: string;
    is_approved?: 'pending' | 'approved' | 'all';
    sort?: 'newest' | 'oldest' | 'highest' | 'lowest';
    search?: string;
  }) =>
    apiClient.get<ApiResponse<FeedbacksResponse>>('/api/admin/feedbacks/', { params }),

  // Одобрить отзыв
  approveFeedback: (feedbackId: string) =>
    apiClient.post<ApiResponse<{ message: string }>>(`/api/admin/feedbacks/${feedbackId}/approve/`),

  // Отклонить отзыв
  rejectFeedback: (feedbackId: string) =>
    apiClient.post<ApiResponse<{ message: string }>>(`/api/admin/feedbacks/${feedbackId}/reject/`),

  // Массовое одобрение
  bulkApproveFeedbacks: (feedbackIds: string[]) =>
    apiClient.post<ApiResponse<{ message: string }>>('/api/admin/feedbacks/bulk-approve/', {
      feedback_ids: feedbackIds
    }),

  // Массовое отклонение
  bulkRejectFeedbacks: (feedbackIds: string[]) =>
    apiClient.post<ApiResponse<{ message: string }>>('/api/admin/feedbacks/bulk-reject/', {
      feedback_ids: feedbackIds
    }),
};